export var createNotImplementedMethod = function () {
    return function () {
        throw new Error('Not implemented');
    };
};
